import { Observable } from 'rxjs';

import { Article } from '../../../domain/article/article';

export abstract class ArticleRepositoryPort {
	public abstract observeArticlesByIds(ids: string[]): Observable<Article[]>;

	public abstract saveArticles(articles: Article[]): Promise<void>;
}
